import type { TFunction } from "i18next";

import { getConfigActionColumn, getConfigStatusColumn } from "features/shared/lib/technical-config-tab/tableHeaders";
import { getRoundedNumericColumn, getTableTypicalColumn } from "utils/components";

import type { ConstructionGroup } from "../model/types";
import type { LayeredConstructionVariant } from "../model/variants";

type GroupTableHeaderOptions = {
  onConfigure: (group: ConstructionGroup) => void;
  t: TFunction;
  variant: LayeredConstructionVariant;
};

const i18nKey = (variant: LayeredConstructionVariant, key: string) => `TechnicalData.${variant.i18nKey}.${key}`;

export const getGroupTableHeaders = ({ onConfigure, t, variant }: GroupTableHeaderOptions) => [
  getTableTypicalColumn({
    dataKey: "userDefinedType",
    isReadOnly: true,
    label: t(i18nKey(variant, "columns.userDefinedType")),
  }),
  getTableTypicalColumn({
    dataKey: "mark",
    isReadOnly: true,
    label: t(i18nKey(variant, "columns.mark")),
  }),
  getRoundedNumericColumn({
    dataKey: "amount",
    isReadOnly: true,
    label: t(i18nKey(variant, "columns.amount")),
  }),
  getRoundedNumericColumn({
    dataKey: "totalArea",
    isReadOnly: true,
    label: t(i18nKey(variant, "columns.totalArea")),
  }),
  getConfigStatusColumn<ConstructionGroup>({
    configuredLabel: t(i18nKey(variant, "hasConfig")),
    dataKey: "hasTechnology",
    isConfigured: (row) => row.hasTechnology,
    label: t(i18nKey(variant, "columns.configStatus")),
    notConfiguredLabel: t(i18nKey(variant, "noConfig")),
  }),
  getConfigActionColumn<ConstructionGroup>({
    configureLabel: t(i18nKey(variant, "columns.config")),
    minWidth: "4.5rem",
    onConfigure,
  }),
];
